import React, { useEffect, useState } from 'react';
import { Popover } from '@mui/material';
import { FindLoad, FindSuccessItem, Images } from 'utils';

export const MoreActions = ({ item, handleAction, actionType, buttonsList }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const openPopper = Boolean(anchorEl);
    const id = openPopper ? 'simple-popover' : undefined;
    const loader = FindLoad(actionType);
    const success = FindSuccessItem(actionType);

    useEffect(() => {
        if (success && anchorEl) {
            setAnchorEl(null);
        }
    }, [success]);

    const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(null);
    };

    return (
        <div>
            <button className="new-action-btn-box-small" onClick={handleClick}>
                <img src={Images.moreGrayIcon} alt="icon" />
            </button>
            <Popover
                id={id}
                open={openPopper}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 150,
                    },
                }}>
                <div className="more-actions-popover">
                    {buttonsList?.map(
                        (i, j) =>
                            i && (
                                <button
                                    key={j}
                                    onClick={(e) => {
                                        handleAction(e, item, i?.actionName);
                                        handleClose(e);
                                    }}>
                                    <div className="flex-align-center" style={{ gap: 8 }}>
                                        <img
                                            src={i?.icon}
                                            alt="icon"
                                            style={
                                                i?.originalColor
                                                    ? {}
                                                    : {
                                                          filter: 'brightness(0) saturate(100%) invert(32%) sepia(5%) saturate(2366%) hue-rotate(177deg) brightness(92%) contrast(88%)',
                                                      }
                                            }
                                        />
                                        <p>{i?.text}</p>
                                    </div>
                                </button>
                            )
                    )}
                </div>
            </Popover>
        </div>
    );
};
